import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IConfigState } from './config';

const exampleStateSelector = createFeatureSelector<IConfigState>('config');

export const selectBasepath = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.basepath
);

export const selectIsMaintainance = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.isMaintainance
);

export const selectCaptchaLength = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.captchaLength
);

export const selectTentativeLogin = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.tentativeLogin
);

export const selectApplicationVersion = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.applicationVersion || ''
);

export const selectToastNotification = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.notificationMessage
);

export const selectRegioni = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.regioni
);

export const selectProvince = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.province
)

export const selectComuni = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.comuni
)

export const selectCatalogoAppartenenza = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.catalogoAppartenenza
)

export const selectClasseAppartenenza = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.classeAppartenenza
)

export const selectCampiUtenteConfig = createSelector(
  exampleStateSelector,
  (state: IConfigState) => state.operatoreBO
)